import {Component, EventEmitter, forwardRef, Injector, Input, Output} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component"
import {
    CompositeProductEditPageComponent
} from "../../composite-product/composite-product-edit-page/composite-product-edit-page.component"
import {AbstractColumnComponent} from "../../../framework/entity/grid/abstract-column.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-sellable-edit-link-column",
    templateUrl: "./sellable-edit-link-column.component.html",
    styleUrls: ["./sellable-edit-link-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => SellableEditLinkColumnComponent), multi: true}
    ]
})
export class SellableEditLinkColumnComponent extends AbstractColumnComponent {
    @Input() componentPath: string;
    @Input() editMode: EditMode;
    @Input() discontinuedLabel: string = "wbo.common.label.discontinued";
    @Input() unavailableLabel: string = "wbo.common.label.unavailable";
    @Input() notSoldLabel: string = "wbo.common.label.notSold";

    @Output() onSave: EventEmitter<EntityData<any>> = new EventEmitter<EntityData<any>>();

    ProductLineEditPageComponent = ProductLineEditPageComponent;
    CompositeProductEditPageComponent = CompositeProductEditPageComponent;

    constructor(injector: Injector) {
        super(injector);
        this.linkable = true;
    }

    dataItemSaved(dataItem: EntityData<any>, saved: EntityData<any>): void {
        this.editGridService.editGrid.closeEditor();
        EntityData.getField(dataItem, this.componentPath).assign(saved);
        this.onSave.emit(saved);
    }
}
